import { compose, withProps } from 'recompose'

import VCMDiagnosticPage from '../components/VCMDiagnostic'
import { withInitialData } from '../components/hoc'

export default compose(
  withProps({
    title: 'common:vcm-page',
    contentImage: ''
  }),
  withInitialData
)(VCMDiagnosticPage)




// WEBPACK FOOTER //
// ./pages/vcm-diagnostic.js